export default {
  admn: {
    // components.poster.episode.color
    background: "black !important",
    backgroundRGB: "241, 241, 241",
    color: {
      primary: "#D02D2E",
      secondary: "#f1f1f1",
      secondaryRGB: "transparent",
      secondaryLight: "#e8e4f1",
      white: "#FFFFFF"
    },
    components: {
      settingsButton: {
        textTransform: {
          primary: ""
        },

        font: {
          color: {
            primary: "rgba(255, 255, 255, 1) !important",
            secondary: "rgba(255, 255, 255, 1) !important",
            admn: "rgba(255, 255, 255, 1) !important"
          },
          colorFocused: {
            primary: "rgba(255, 255, 255, 1) !important",
            secondary: "rgba(255, 255, 255, 1) !important",
            admn: "#000000 !important"
          },
          weight: {
            primary: 900,
            secondary: 300
          }
        },
        background: {
          color: {
            primary: "rgba(66, 66, 66, 1)",
            secondary: "rgba(255, 255, 255, 1) !important"
          },
          colorFocused: {
            primary: "#D02D2E",
            secondary: "rgba(255, 255, 255, 1) !important",
            default: "#ffffff"
          },
          secondary: "rgba(66, 66, 66, 1) "
        },
        icon: {
          color: {
            primary: "rgba(255, 255, 255, 1)"
          },
          colorFocused: {
            primary: "rgba(255, 255, 255, 1)",
            secondary: "rgba(255, 255, 255, 1)"
          }
        }
      },
      cwIcon: {
        color: {
          secondary: "rgba(66, 66, 66, 1)"
        }
      },
      toast: {
        font: {
          color: "#FFFFFF"
        },
        icon: {
          color: "#FFFFFF"
        }
      },
      admnSideMenu: {
        color: "#FFFFFF"
      },
      subThemeBackground: {
        color: "#000000",
        backgroundRGB: "0, 0, 0"
      },
      headerMenu: {
        background: {
          color: "#000000"
        }
        // width: {
        //   default: "17rem"
        // }
      },
      logo: {
        path:
          "M76.3 28.8l5.2-10.4 5.2 10.4H76.3zM60.1 43.1h9l3.3-6.6h18.3l3.3 6.6h9L81.6.7 60.1 43.1zM67.8.9H34.2v7.7h12.5v34.5h8.6V8.6h12.5zM119.8 19.4h-6.2V8.6h6.2c4.6 0 7.1 1.9 7.1 5.4s-2.6 5.4-7.1 5.4m15.8-5.6c0-3.7-1.3-6.9-3.9-9.2-2.6-2.4-6.4-3.7-10.8-3.7H105v42.2h8.6V27.7h6.1l8.9 15.4h9.8l-10-17.5c6.3-2.9 7.2-8.7 7.2-11.8M177 .9h-34.9v7.7H162l-21.6 34.5h36.1v-7.7h-21.2zM19.1 18.1c-6.9-1.6-9.4-2.8-9.4-6 0-2.7 2.5-4.4 6.1-4.4 5.6 0 10.6 3.9 12 5l3.6-7.3C26.9 2 21.8.2 15.9.2 7.3.2 1.2 5.3 1.2 12.7c0 8.1 5.2 10.9 14.2 13 7.5 1.7 8.9 3.2 8.9 5.7 0 2.9-2.6 4.7-6.7 4.7-5 0-9.1-1.9-13.9-6.3L.2 37.3c4.9 4.2 10.9 6.4 17.2 6.4 9.3 0 15.3-5 15.3-13 0-6.5-3.9-10.2-13.6-12.6M183.3.9h13.9c7.4 0 12.8 4.6 12.8 12.3s-5.5 12.4-12.8 12.4h-11.3v17.5h-2.6V.9zM197 23.2c6.2 0 10.3-3.7 10.3-10s-4.1-9.9-10.3-9.9h-11.2v19.9H197zM219 .9h2.6v39.8h20.1v2.4H219V.9zM270.4 28.5h-17.9L247 43.1h-2.8L260 .9h2.8l15.8 42.2h-2.8l-5.4-14.6zm-9-24.6s-.9 3.3-1.6 5.1l-6.5 17.1h16.1L263.1 9c-.7-1.8-1.6-5.1-1.6-5.1h-.1zM292.4 24.8L278 .9h3l10 16.6c1.2 2.1 2.6 4.8 2.6 4.8h.1s1.3-2.7 2.6-4.8l10-16.6h3L295 24.8v18.3h-2.6V24.8z",
        viewBox: "0 0 310.1 43.9",
        color: "#f1f1f1",
        width: "14.84vw",
        height: "2.1vw"
      },
      carousel: {
        shadowBorderWidth: "6px",
        borderRadius: "18px"
      },
      image: {
        fallback: {
          icon: "playStroke",
          iconColor: "#000000",
          color: "#000000",
          backgroundColor: "#000000"
        },
        overlay: {
          icon: {
            focusColor: "#ffffff",
            color: "#ffffff"
          },
          color: "#000000"
          // backgroundColor: "#e8e4f1"
        }
      },
      arrowScroll: {
        font: {
          color: "#D02D2E"
        },
        icon: {
          color: "#D02D2E"
        }
      },

      progress: {
        background: {
          playback: {
            gradient: "#7AFFFB"
          }
        },
        backgroundColor: "#D02D2E",
        backgroundPlaybackLight: "#ce9ffc",
        backgroundPlaybackDark: "#D02D2E"
      },
      poster: {
        episode: {
          color: "rgba(255, 255, 255, 1)",
          figcaption: {
            color: "rgba(255, 255, 255, 1)"
          }
        }
      },
      detail: {
        heading: {
          color: "#261e32"
        },
        synopsis: {
          color: "#261e32"
        },
        info: {
          color: "#585360"
        },
        data: {
          color: "#585360"
        }
      },
      button: {
        border: {
          colorFocused: "#D02D2E !important"
        },
        font: {
          color: {
            primary: "rgba(255, 255, 255, 1) !important",
            secondary: "rgba(255, 255, 255, 1) !important"
          },
          colorFocused: {
            primary: "rgba(255, 255, 255, 1) !important",
            secondary: "rgba(255, 255, 255, 1) !important"
          },
          weight: {
            primary: 900,
            secondary: 300
          }
        },
        background: {
          color: {
            primary: "rgba(66, 66, 66, 1)",
            secondary: "rgba(255, 255, 255, 1) !important"
          },
          colorFocused: {
            primary: "#D02D2E",
            secondary: "rgba(255, 255, 255, 1) !important"
          }
        },
        icon: {
          color: {
            primary: "rgba(255, 255, 255, 1)"
          },
          colorFocused: {
            primary: "rgba(255, 255, 255, 1)",
            secondary: "rgba(255, 255, 255, 1)"
          }
        }
      },
      itemMainMenu: {
        background: "#e8e4f1",
        fontWeight: 700,
        icon: {
          color: "#D02D2E"
        }
      },
      itemSecondaryMenu: {
        color: {
          default: "rgba(255, 255, 255, 1)",
          focused: "#f1f1f1"
        },
        background: {
          focused: "#D02D2E",
          selected: "#dfd2ff"
        }
      },
      keyboard: {
        key: {
          border: {
            color: "#f1f1f1"
          },
          background: {
            default: "#e8e4f1",
            focused: "#D02D2E"
          },
          color: {
            default: "#D02D2E",
            focused: "#f1f1f1"
          }
        }
      },
      input: {
        font: {
          color: {
            default: "#676d70",
            active: "#D02D2E"
          }
        }
      },
      loading: {
        overlay: {
          colorRGB: "241 241 241"
        },
        icon: {
          color: "#D02D2E"
        }
      },
      text: {
        color: {
          primary: "#D02D2E"
        }
      },
      toast: {
        font: {
          color: "#FFFFFF"
          // shadowColor: "#f1f1f1"
        },
        backgroundColor: "#e8e4f1",
        icon: {
          color: "#FFFFFF"
        }
      }
    }
  }
  // kids: {
  //   background: "#f1f1f1",
  //   backgroundRGB: "241, 241, 241",
  //   color: {
  //     primary: "#614565",
  //     secondary: "#f1f1f1",
  //     secondaryRGB: "241, 241, 241",
  //     secondaryLight: "#e8e4f1"
  //   },
  //   components: {
  //     logo: {
  //       path:
  //         "M76.3 28.8l5.2-10.4 5.2 10.4H76.3zM60.1 43.1h9l3.3-6.6h18.3l3.3 6.6h9L81.6.7 60.1 43.1zM67.8.9H34.2v7.7h12.5v34.5h8.6V8.6h12.5zM119.8 19.4h-6.2V8.6h6.2c4.6 0 7.1 1.9 7.1 5.4s-2.6 5.4-7.1 5.4m15.8-5.6c0-3.7-1.3-6.9-3.9-9.2-2.6-2.4-6.4-3.7-10.8-3.7H105v42.2h8.6V27.7h6.1l8.9 15.4h9.8l-10-17.5c6.3-2.9 7.2-8.7 7.2-11.8M177 .9h-34.9v7.7H162l-21.6 34.5h36.1v-7.7h-21.2zM19.1 18.1c-6.9-1.6-9.4-2.8-9.4-6 0-2.7 2.5-4.4 6.1-4.4 5.6 0 10.6 3.9 12 5l3.6-7.3C26.9 2 21.8.2 15.9.2 7.3.2 1.2 5.3 1.2 12.7c0 8.1 5.2 10.9 14.2 13 7.5 1.7 8.9 3.2 8.9 5.7 0 2.9-2.6 4.7-6.7 4.7-5 0-9.1-1.9-13.9-6.3L.2 37.3c4.9 4.2 10.9 6.4 17.2 6.4 9.3 0 15.3-5 15.3-13 0-6.5-3.9-10.2-13.6-12.6M183.3.9h13.9c7.4 0 12.8 4.6 12.8 12.3s-5.5 12.4-12.8 12.4h-11.3v17.5h-2.6V.9zM197 23.2c6.2 0 10.3-3.7 10.3-10s-4.1-9.9-10.3-9.9h-11.2v19.9H197zM219 .9h2.6v39.8h20.1v2.4H219V.9zM270.4 28.5h-17.9L247 43.1h-2.8L260 .9h2.8l15.8 42.2h-2.8l-5.4-14.6zm-9-24.6s-.9 3.3-1.6 5.1l-6.5 17.1h16.1L263.1 9c-.7-1.8-1.6-5.1-1.6-5.1h-.1zM292.4 24.8L278 .9h3l10 16.6c1.2 2.1 2.6 4.8 2.6 4.8h.1s1.3-2.7 2.6-4.8l10-16.6h3L295 24.8v18.3h-2.6V24.8z",
  //       viewBox: "0 0 310.1 43.9",
  //       color: "#f1f1f1",
  //       width: "14.84vw",
  //       height: "2.1vw"
  //     },
  //     carousel: {
  //       shadowBorderWidth: "6px",
  //       borderRadius: "18px"
  //     },
  //     image: {
  //       fallback: {
  //         icon: "playStroke",
  //         iconColor: "#614565",
  //         color: "#614565",
  //         backgroundColor: "#e8e4f1"
  //       }
  //     },
  //     arrowScroll: {
  //       font: {
  //         color: "#614565"
  //       },
  //       icon: {
  //         color: "#614565"
  //       }
  //     },
  //     progress: {
  //       backgroundColor: "#614565",
  //       backgroundPlaybackLight: "#ce9ffc",
  //       backgroundPlaybackDark: "#614565"
  //     },
  //     poster: {
  //       episode: {
  //         color: "#261e32",
  //         figcaption: {
  //           color: "#f1f1f1"
  //         }
  //       }
  //     },
  //     detail: {
  //       heading: {
  //         color: "#261e32"
  //       },
  //       synopsis: {
  //         color: "#261e32"
  //       },
  //       info: {
  //         color: "#585360"
  //       },
  //       data: {
  //         color: "#585360"
  //       }
  //     },
  //     button: {
  //       border: {
  //         colorFocused: "#614565"
  //       },
  //       font: {
  //         color: {
  //           primary: "#614565",
  //           secondary: "#614565"
  //         },
  //         colorFocused: {
  //           primary: "#f1f1f1",
  //           secondary: "#614565"
  //         },
  //         weight: {
  //           primary: 700,
  //           secondary: 300
  //         }
  //       },
  //       background: {
  //         color: {
  //           primary: "#e8e4f1",
  //           secondary: "#e8e4f1"
  //         },
  //         colorFocused: {
  //           primary: "#614565",
  //           secondary: "#e8e4f1"
  //         }
  //       },
  //       icon: {
  //         color: "#614565",
  //         colorFocused: {
  //           primary: "#f1f1f1",
  //           secondary: "#614565"
  //         }
  //       }
  //     },
  //     itemMainMenu: {
  //       background: "#e8e4f1",
  //       fontWeight: 700,
  //       icon: {
  //         color: "#614565"
  //       }
  //     },
  //     itemSecondaryMenu: {
  //       color: {
  //         default: "#614565",
  //         focused: "#f1f1f1"
  //       },
  //       background: {
  //         focused: "#614565",
  //         selected: "#dfd2ff"
  //       }
  //     },
  //     keyboard: {
  //       key: {
  //         border: {
  //           color: "#f1f1f1"
  //         },
  //         background: {
  //           default: "#e8e4f1",
  //           focused: "#614565"
  //         },
  //         color: {
  //           default: "#614565",
  //           focused: "#f1f1f1"
  //         }
  //       }
  //     },
  //     input: {
  //       font: {
  //         color: {
  //           default: "#676d70",
  //           active: "#614565"
  //         }
  //       }
  //     },
  //     loading: {
  //       overlay: {
  //         colorRGB: "241 241 241"
  //       },
  //       icon: {
  //         color: "#614565"
  //       }
  //     },
  //     text: {
  //       color: {
  //         primary: "#614565"
  //       }
  //     },
  //     toast: {
  //       font: {
  //         color: "#614565",
  //         shadowColor: "#f1f1f1"
  //       },
  //       backgroundColor: "#e8e4f1",
  //       icon: {
  //         color: "#614565"
  //       }
  //     }
  //   }
  // },
  // disney: {
  //   background:
  //     "http://mena-img-cdn-lb.aws.playco.com/prd-peg-data/default/bigscreen/images/Themes/disney/background.jpg"
  // }
};
